import {
  ADD_POST_REF,
  UPDATE_POST_REF,
  SET_POST_DATA,
  GET_NEXT_POSTS,
  GET_POST_DATA_FROM_REFERENCE,
  MERGE_POST,
  MERGE_POST_DATA,
  UPDATE_POSTS_DATES,
  UPDATE_POSTS_PUBLISHED_AT,
  REFRESH_POSTS_PUBLISHED_AT,
  DELETE_POST,
  RESET_POSTS_ACTION,
  RESET_POSTS
} from '../actions/postQueries'
import firebase from 'firebase'
import { _ } from 'vue-underscore'
import { postsDB } from '../../firestoreDB'
import { getUserPostsRefsPage } from '@/helper/paginate'
import { docToPostRef, docToPostData } from '@/converters/postConverter'
import { getIndexForNewItem, addListItem, getIndexForItem } from '@/helper/helper'

const getDefaultState = () => ({
  postsData: [],
  postsRefs: [],
  currentPost: null,
  lastPostPublishedAt: new Date().getTime() / 1000
})

const state = getDefaultState()

const getters = {
  getPostsData: state => _.compact(state.postsData),
  getPostsRefs: state => state.postsRefs,
  getLastPostPublishedAt: state => state.lastPostPublishedAt,
  getCurrentPost: state => state.currentPost
}
const actions = {
  [GET_NEXT_POSTS]: ({ getters, dispatch, commit }) => {
    return new Promise((resolve) => {
      const last = _.last(getters.getPostsRefs)
      const source = getUserPostsRefsPage(last && last.score)
      source.onSnapshot({ includeMetadataChanges: true }, snapshot => {
        snapshot.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          let postRef = null
          switch (docChanged.type) {
            case 'added':
              postRef = docToPostRef(doc)
              commit(ADD_POST_REF, postRef)
              dispatch(GET_POST_DATA_FROM_REFERENCE, postRef)
              break
            case 'modified':
              postRef = docToPostRef(doc)
              commit(UPDATE_POST_REF, postRef)
              break
            case 'removed':
              commit(DELETE_POST, doc.id)
              break
            default:
              break
          }
        })
        resolve(true)
      })
    })
  },
  [GET_POST_DATA_FROM_REFERENCE]: ({ commit, dispatch, getters }, item) => {
    postsDB
      .where(firebase.firestore.FieldPath.documentId(), '==', item.key)
      .onSnapshot({ includeMetadataChanges: true }, snapshotDoc => {
        snapshotDoc.docChanges().forEach(docChanged => {
          const doc = docChanged.doc
          let postData = null
          switch (docChanged.type) {
            case 'added':
              postData = docToPostData(doc, item)
              commit(SET_POST_DATA, postData)
              dispatch(UPDATE_POSTS_DATES)
              break
            case 'modified':
              postData = docToPostData(doc, item)
              commit(SET_POST_DATA, postData)
              dispatch(UPDATE_POSTS_DATES)
              break
            case 'removed':
              commit(DELETE_POST, doc.id)
              break
            default:
              break
          }
        })
      })
  },
  [UPDATE_POSTS_DATES]: ({ commit, getters }) => {
    const twoDaysInSeconds = 172800
    const minute = 60
    const todaySeconds = new Date().getTime() / 1000 // today seconds
    if (todaySeconds - getters.getLastPostPublishedAt > minute) {
      getters.getPostsData.map((item, index) => {
        if (item) {
          let seconds = item.published_at.seconds
          const diff = todaySeconds - seconds
          if (diff <= twoDaysInSeconds) {
            commit(REFRESH_POSTS_PUBLISHED_AT, { item, index })
          } else return true
        }
      })
      commit(UPDATE_POSTS_PUBLISHED_AT, todaySeconds)
    }
  },
  [RESET_POSTS_ACTION]: ({ commit }) => {
    commit(RESET_POSTS)
  },
  [MERGE_POST]: ({ commit }, value) => {
    commit(MERGE_POST_DATA, value)
  }
}

const mutations = {
  [ADD_POST_REF]: (state, elemRef) => {
    const newIndexRef = getIndexForNewItem(state.postsRefs, 'score', elemRef.score)
    state.postsRefs.splice(newIndexRef, 0, elemRef)
    state.postsData.splice(newIndexRef, 0, null)
  },
  [UPDATE_POST_REF]: (state, elemRef) => {
    const oldIndexRef = getIndexForItem(state.postsRefs, 'key', elemRef.key)
    const oldElemeRef = state.postsRefs[oldIndexRef]
    let elemData = null
    let newIndexRef = -1
    let hasIndexChanged = oldElemeRef.score !== elemRef.score
    if (hasIndexChanged) {
      newIndexRef = getIndexForNewItem(state.postsRefs, 'score', elemRef.score)
      hasIndexChanged = newIndexRef !== oldIndexRef
    }
    if (hasIndexChanged) {
      state.postsRefs.splice(oldIndexRef, 1)
      let elemDataList = state.postsData.splice(oldIndexRef, 1)
      elemData = elemDataList[0] || null
      newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef // Testear
      state.postsRefs = addListItem([...state.postsRefs], elemRef, newIndexRef)
      elemData = elemData ? {...elemData, ...elemRef} : elemData
      state.postsData = addListItem([...state.postsData], elemData, newIndexRef)
    } else {
      state.postsRefs[oldIndexRef] = elemRef
      let postsData = state.postsData
      elemData = postsData[oldIndexRef]
      elemData = elemData ? {...elemData, ...elemRef} : elemData
      postsData[oldIndexRef] = elemData
      state.postsData = [...postsData]
    }
  },
  [SET_POST_DATA]: (state, elemData) => {
    const index = getIndexForItem(state.postsRefs, 'key', elemData.key)
    if (index > -1) {
      let postsData = [...state.postsData]
      postsData[index] = elemData
      state.postsData = postsData
    }
  },
  [MERGE_POST_DATA]: (state, value) => {
    const { key, data } = value
    const indexData = getIndexForItem(state.postsRefs, 'key', key)
    if (indexData > -1) {
      state.postsData[indexData] = {...state.postsData[indexData], like: data.like}
    }
  },
  [REFRESH_POSTS_PUBLISHED_AT]: (state, { item, index }) => {
    state.postsData[index] = {...state.postsData[index], moment: Math.random()}
  },
  [UPDATE_POSTS_PUBLISHED_AT]: (state, dateTimeSeconds) => {
    state.lastPostPublishedAt = dateTimeSeconds
  },
  [DELETE_POST]: (state, key) => {
    const postIndex = getIndexForItem(state.postsRefs, 'key', key)
    if (postIndex > -1) {
      state.postsRefs.splice(postIndex, 1)
      state.postsData.splice(postIndex, 1)
    }
  },
  [RESET_POSTS]: state => {
    Object.assign(state, getDefaultState())
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/postsQuery.js